import React from 'react';
import OrderPage from './components/OrderPage';
import { orderStatus } from '../../../constants/orderStatus';

const ReadyForPickup = () => {
  const bulkActionOptions = [
    {
      label: 'Picked Up',
      value: 'pickedUp',
    },
    {
      label: 'Cancel',
      value: 'cancelOrder',
    },
    {
      label: 'Generate Manifest',
      value: 'Generate Manifest',
    },
    {
      label: 'Assigned To Porter',
      value: 'assignedToPorter',
    },
    {
      label: 'Assigned To Biker',
      value: 'assignedToBiker',
    },
    {
      label: 'Courier',
      value: 'courier',
    },
  ];
  return (
    <div>
      <OrderPage
        type={orderStatus.readyForPickup}
        bulkActionOptions={bulkActionOptions}
      />
    </div>
  );
};

export default ReadyForPickup;
